import { memo } from 'react';
import Chip from '@mui/material/Chip';
import _map from 'lodash/map';
// Local Files
import { Root } from '../Filter/Filter.styled';
import { URGENTLY_DOCUMENT_TYPES } from 'helpers/urgentlyDocumentTypes';

const UrgentlyFilter = ({ urgentlyDocumentType, filterUrgentlyType, unfilterUrgentlyType, disabled }) => {
  return (
    <Root>
      { !!URGENTLY_DOCUMENT_TYPES.length && _map(URGENTLY_DOCUMENT_TYPES, ({ id: typeId, name }) => 
        <Chip
          key={typeId}
          label={name}
          selected={urgentlyDocumentType === typeId}
          color='primary'
          variant={urgentlyDocumentType === typeId ? 'filled' : 'outlined'}
          onClick={() => filterUrgentlyType(typeId)}
          onDelete={urgentlyDocumentType === typeId ? unfilterUrgentlyType : null}
          disabled={disabled}
        />
      )}
    </Root>
  );
};

export default memo(UrgentlyFilter);
